<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 10.06 10.06" fill="currentColor">
    <path d="M5.657,4.4V0H4.4V4.4H0V5.657H4.4v4.4H5.657v-4.4h4.4V4.4Z" />
  </svg>
</template>